import { useAlertContext } from '../common';
import { Button, styled } from '@mui/material';
import configjson from '../config.json';
import { always } from 'rambda';
import { compose as lcompose } from 'lodash/fp';

export const Signup = () => {
  const { setAlert } = useAlertContext();

  return (
    <Action
      onClick={lcompose(
        setAlert,
        always(a => ({
          ...a,
          title: 'CSOS Signup',

          message: always(
            <Messages dangerouslySetInnerHTML={{ __html: configjson.signup }} />
          ),

          okAction: true,
          cancelAction: false,
          isOpen: true,
          ok: always(
            <Button
              component="a"
              variant="contained"
              color="primary"
              href={process.env.REACT_APP_SIGNUP_URL}>
              <span style={{ color: 'white' }}>Sign Up</span>
            </Button>
          ),
        }))
      )}
      variant="contained"
      color="secondary"
      disableRipple>
      Sign Up
    </Action>
  );
};

const Action = styled(Button)(({ theme }) => ({
  width: '100%',

  '&:focus-visible': {
    filter: 'contrast(200%)',
  },
}));

const Messages = styled('p')(({ theme }) => ({ '& > ol': { margin: '0px' } }));
